import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { makeStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import DashboardIcon from '@material-ui/icons/Dashboard';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import PeopleIcon from '@material-ui/icons/People';
import BarChartIcon from '@material-ui/icons/BarChart';
import LayersIcon from '@material-ui/icons/Layers';
import AssignmentIcon from '@material-ui/icons/Assignment';
import Filter1Icon from '@material-ui/icons/Filter1';
import Filter2Icon from '@material-ui/icons/Filter2';
import Filter3Icon from '@material-ui/icons/Filter3';
import Filter4Icon from '@material-ui/icons/Filter4';
import PersonIcon from '@material-ui/icons/Person';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import HealingIcon from '@material-ui/icons/Healing';
import EventIcon from '@material-ui/icons/Event';
import My_account from './my_account'
import { useFeature } from "../../featureGating/featureGating";

const onClickProfile = () => {
  window.location.replace("/myaccount");
}

const onClickPlan = () => {
  window.location.replace("/physiotherapeutic_plan");
}

// const onClickRecovery = () => {
//   window.location.replace("/recovery_phases");
// }

const onClickDiagnosis = () => {
  window.location.replace("/learn_about_your_pain");
}

const onClickOverview = () => {
  window.location.replace("/overview_of_journey");
}

const onClickAppointments = () => {
  window.location.replace("/my_appointments");
}

const useStyles = makeStyles((theme) => ({
  listText: {
    paddingLeft: 5,
    fontSize: '0.85rem',
    [theme.breakpoints.down('lg')]: { fontSize: '0.82rem' },
    [theme.breakpoints.down('md')]: { fontSize: '0.78rem' },
    [theme.breakpoints.down('sm')]: { fontSize: '0.74rem' },
    [theme.breakpoints.down('xs')]: { fontSize: '0.64rem' },
  },
}));

export function MainListItems({ open }) {
  const classes = useStyles();
  const hasPatientApp = useFeature('patient_app');
  const hasMonitoring = useFeature('remote_monitoring');
  const hasBooking = useFeature('online_booking');
  return (
    <div>
      <ListItem button onClick={onClickProfile} style={{color: "#002D55", backgroundColor: "#FFFFFF"}}>
        <ListItemIcon style={{ minWidth: 'clamp(26px, 1.67vw, 32px)' }}>
          <PersonIcon style={{color: "#002D55", backgroundColor: "#FFFFFF", fontSize: 'clamp(20px, 1.25vw, 24px)'}}/>
        </ListItemIcon>
        {open && <ListItemText primary="My account" primaryTypographyProps={{ className: classes.listText }} />}
      </ListItem>
      <ListItem button onClick={onClickDiagnosis} style={{color: "#002D55", backgroundColor: "#FFFFFF"}}>
        <ListItemIcon style={{ minWidth: 'clamp(26px, 1.67vw, 32px)' }}>
          <HealingIcon style={{color: "#002D55", backgroundColor: "#FFFFFF", fontSize: 'clamp(20px, 1.25vw, 24px)'}}/>
        </ListItemIcon>
        {open && <ListItemText primary="Diagnosis" primaryTypographyProps={{ className: classes.listText }} />}
      </ListItem>
      {hasPatientApp && (
        <ListItem button onClick={onClickPlan} style={{color: "#002D55", backgroundColor: "#FFFFFF"}}>
          <ListItemIcon style={{ minWidth: 'clamp(26px, 1.67vw, 32px)' }}>
            <DashboardIcon style={{color: "#002D55", backgroundColor: "#FFFFFF", fontSize: 'clamp(20px, 1.25vw, 24px)'}}/>
          </ListItemIcon>
          {open && <ListItemText primary="Physiotherapy plan" primaryTypographyProps={{ className: classes.listText }} />}
        </ListItem>
      )}
      {hasMonitoring && (
        <ListItem button onClick={onClickOverview} style={{color: "#002D55", backgroundColor: "#FFFFFF"}}>
          <ListItemIcon style={{ minWidth: 'clamp(26px, 1.67vw, 32px)' }}>
            <BarChartIcon style={{color: "#002D55", backgroundColor: "#FFFFFF", fontSize: 'clamp(20px, 1.25vw, 24px)'}}/>
          </ListItemIcon>
          {open && <ListItemText primary="Progress" primaryTypographyProps={{ className: classes.listText }} />}
        </ListItem>
      )}
      {hasBooking && (
        <ListItem button onClick={onClickAppointments} style={{color: "#002D55", backgroundColor: "#FFFFFF"}}>
          <ListItemIcon style={{ minWidth: 'clamp(26px, 1.67vw, 32px)' }}>
            <EventIcon style={{color: "#002D55", backgroundColor: "#FFFFFF", fontSize: 'clamp(20px, 1.25vw, 24px)'}}/>
          </ListItemIcon>
          {open && <ListItemText primary="Appointments" primaryTypographyProps={{ className: classes.listText }} />}
        </ListItem>
      )}
    </div>
  );
}

export const SecondaryListItems = ({ open }) => {
  const classes = useStyles();
  const token = useSelector(state => state.auth.token);
  const [loading, setLoading] = useState(true);
  const [phaseIndex, setPhaseIndex] = useState(null);
  const [isFetching, setIsFetching] = useState(false)
  const [phaseData, setPhaseData] = useState({
    progress: "?",
    title: "?"
  })
  const [diagnosis, setDiagnosis] = useState({
    title: "",
    explainer: "",
    identifier: ""
  })

  useEffect(() => {
    if (token) {
      fetchDiagnosisData();
    }
    // eslint-disable-next-line
  }, [token]);

  const fetchDiagnosisData = async () => {
    setIsFetching(true);
    try {
      const response = await fetch("https://api.virtus-one.com/treatment/diagnosis/", {
        headers: {
          "Authorization": `Token ${token}`
        },
        method: "GET",
      });
      if (response.ok) {
        const data = await response.json();
        if (data[0]?.diagnosis) {
          setDiagnosis({ ...data[0].diagnosis });
          fetchPhaseData(data[0].diagnosis);
        }
      } else {
        console.error('Unable to fetch diagnosis:', response.status);
      }
    } catch (error) {
      console.error('Unable to fetch diagnosis:', error);
    } finally {
      setIsFetching(false);
    }
  }

  const fetchPhaseData = async (__diagnosis) => {
    try {
      const response = await fetch("https://api.virtus-one.com/treatment/phase/progress/" + __diagnosis.identifier, {
        headers: {
          "Authorization": `Token ${token}`
        },
        method: "GET",
      })
      if (response.ok) {
        const data = await response.json();
        setPhaseData({
          progress: data.progress,
          title: data.name,
          phaseIndex: data.phaseIndex
        });
        setPhaseIndex(data.phaseIndex);
      } else {
        console.error('Unable to fetch phase progress:', response.status);
      }
    } catch (error) {
      console.error('Unable to fetch phase progress:', error);
    }
  }

  return (
    <div>
      <ListSubheader style={{ marginTop: "16px" }}><ListItemText primary="" /> </ListSubheader>
      <ListItem button style={{color: "#002D55", backgroundColor: phaseIndex === 0 ? "#f5f5f5" : "#FFFFFF"}}>
        <ListItemIcon style={{ minWidth: 'clamp(24px, 1.67vw, 32px)' }}>
          <Filter1Icon style={{color: phaseIndex === 0 ? "orange" : "#002D55", backgroundColor: "transparent", fontSize: 'clamp(18px, 1.25vw, 24px)'}}/>
        </ListItemIcon>
        {open && <ListItemText primary="Control pain" primaryTypographyProps={{ className: classes.listText }} />}
      </ListItem>
      <ListItem button style={{color: "#002D55", backgroundColor: phaseIndex === 1 ? "#f5f5f5" : "#FFFFFF"}}>
        <ListItemIcon style={{ minWidth: 'clamp(24px, 1.67vw, 32px)' }}>
          <Filter2Icon style={{color: phaseIndex === 1 ? "orange" : "#002D55", backgroundColor: "transparent", fontSize: 'clamp(18px, 1.25vw, 24px)'}}/>
        </ListItemIcon>
        {open && <ListItemText primary="Retrain function" primaryTypographyProps={{ className: classes.listText }} />}
      </ListItem>
      <ListItem button style={{color: "#002D55", backgroundColor: phaseIndex === 2 ? "#f5f5f5" : "#FFFFFF"}}>
        <ListItemIcon style={{ minWidth: 'clamp(24px, 1.67vw, 32px)' }}>
          <Filter3Icon style={{color: phaseIndex === 2 ? "orange" : "#002D55", backgroundColor: "transparent", fontSize: 'clamp(18px, 1.25vw, 24px)'}}/>
        </ListItemIcon>
        {open && <ListItemText primary="Challenge it" primaryTypographyProps={{ className: classes.listText }} />}
      </ListItem>
      <ListItem button style={{color: "#002D55", backgroundColor: phaseIndex === 3 ? "#f5f5f5" : "#FFFFFF"}}>
        <ListItemIcon style={{ minWidth: 'clamp(24px, 1.67vw, 32px)' }}>
          <Filter4Icon style={{color: phaseIndex === 3 ? "orange" : "#002D55", backgroundColor: "transparent", fontSize: 'clamp(18px, 1.25vw, 24px)'}}/>
        </ListItemIcon>
        {open && <ListItemText primary="Back to your best" primaryTypographyProps={{ className: classes.listText }} />}
      </ListItem>
    </div>
  );
};